import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class SetForsorjningskallaManuellPaArbetsorderCommand extends BasicCommand<SetForsorjningskallaManuellPaArbetsorderCommand> {
    kundorderradId: number;
    produktionsomradeId: number;
    manuellPaArbetsorder: boolean;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "SetForsorjningskallaManuellPaArbetsorderCommand";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Forsorjningskalla";

    get primaryKey(): IPrimaryKey<SetForsorjningskallaManuellPaArbetsorderCommand> {
        return {
            id: this.kundorderradId,
            poid: this.produktionsomradeId
        };
    }

    constructor(kundorderradId: number, produktionsomradeId: number) {
        super(SetForsorjningskallaManuellPaArbetsorderCommand.$type, SetForsorjningskallaManuellPaArbetsorderCommand.$groupKey, CommandType.Replace);
        this.kundorderradId = kundorderradId;
        this.produktionsomradeId = produktionsomradeId;
    }
}
